export default "__VITE_ASSET__8diPmkcQ__"